import { Product } from "@omni/types/api/product/bff/product.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { OnAddToCartHandler } from "./actionHandlers/onAddToCart.handler";
import { OnSubmitHandler } from "./actionHandlers/onSubmit.handler";
import { ECommerceContextProvider } from "./context/eCommerce.context";
import { TooltipType } from "./eCommerce.types";

export type BaseProps = {
    product: Product<ProductFieldSet.Full>;
    tooltips: {
        homeDelivery: TooltipType;
        pickupInStore: TooltipType;
        serviceProduct: TooltipType;
    };
    infoLink: string;
    contextAwareXfPath: string | null;
    cashbackPagePath: string;
    paintConfiguratorPath: string;
    handlers: {
        onSubmit: OnSubmitHandler;
        onAddToCart: OnAddToCartHandler;
    };
};

export const Base = ({
    children,
    product,
    infoLink,
    tooltips,
    cashbackPagePath,
    contextAwareXfPath,
    paintConfiguratorPath,
    handlers
}: RequireChildrenFor<BaseProps>) => {
    return (
        <ECommerceContextProvider
            product={product}
            infoLink={infoLink}
            tooltips={{
                [DeliveryType.HomeDelivery]: tooltips.homeDelivery,
                [DeliveryType.ClickAndCollect]: tooltips.pickupInStore,
                serviceProduct: tooltips.serviceProduct
            }}
            contextAwareXfPath={contextAwareXfPath}
            paintConfiguratorPath={paintConfiguratorPath}
            cashbackPagePath={cashbackPagePath}
            handlers={handlers}
        >
            {children}
        </ECommerceContextProvider>
    );
};
